import { Flex, NumberFormat, Spacing, Text } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { getCurrentLocale } from '../../../../../../../../utils'

interface BankTransactionsAccountBalanceProps {
  amount: number
  currency: string
}

export const BankTransactionsAccountBalance = ({
  amount,
  currency,
}: BankTransactionsAccountBalanceProps): ReactElement => {
  const { t } = useTranslation()
  const locale = getCurrentLocale()

  const formattedAmount = NumberFormat.getFormattedNumber(amount, locale, { minimumFractionDigits: 2 })

  return (
    <>
      <Text colorVariant="discreet">{t('bank.accounts.total_amount_label')}</Text>
      <Flex alignItems="baseline" gap={Spacing.S8}>
        <Text variant="display" weight="bold">
          {formattedAmount}
        </Text>
        <Text variant="h2">{currency}</Text>
      </Flex>
    </>
  )
}
